export const config = {
  cdn: process.env.VUE_APP_SS_CDN_URL,
  scores_api: process.env.VUE_APP_SS_API_URL,
  api_subscription_key: process.env.VUE_APP_SS_API_SUB_KEY,
  feed_api: process.env.VUE_APP_FEED_API_URL,
  feed_auth: process.env.VUE_APP_FEED_API_AUTH,
  dstv_api: process.env.VUE_APP_DSTV_API_URL,
  jw_url: process.env.VUE_APP_SS_JW_URL,
  platform_id: process.env.VUE_APP_PLATFORM_ID || 'explora-ultra',
  ip_api_key: process.env.VUE_APP_IP_API_KEY,
  base_ad_unit: process.env.VUE_APP_BASE_AD_UNIT,
  video_ad_unit: 'Responsive/Supersport',
};
